import * as L from "leaflet";
import * as React from "react";
import FlightMarkersList from "./FlightMarkersList";
import { getDeprecatedUIState, IStoreState } from "../../../redux/rootReducer";
import { connect } from "react-redux";
import { IDeprecatedUIState } from "../../../redux/modules/ui/reducer";
import { IGcpAppDispatchProp } from "../../../redux/store";
import ModeReadonlyGcpRequestLayout from "./ModeReadonlyGcpRequestLayout";
import { userTogglesSidebarVisibility } from "./scenarios";
import IconMenuWhite from "../components/IconMenuWhite";
import { GCPRequestSidebarHeader } from "../components/GCPRequestSidebarHeader";

interface IGcpRequestViewPageProps extends IGcpAppDispatchProp {
  uiState: IDeprecatedUIState;
}

const GcpRequestViewPage = ({
  uiState,
  dispatch,
}: IGcpRequestViewPageProps) => {
  return (
    <ModeReadonlyGcpRequestLayout
      sidebarWidth={244}
      sidebarIsVisible={uiState.sidebarIsVisible}
      sidebarHeader={
        <GCPRequestSidebarHeader
          rightIcon={L.Browser.mobile ? <IconMenuWhite /> : null}
          onRightIconClick={() => {
            dispatch(userTogglesSidebarVisibility());
          }}
        />
      }
      sidebarContent={<FlightMarkersList />}
    />
  );
};

export default connect((state: IStoreState) => ({
  uiState: getDeprecatedUIState(state),
}))(GcpRequestViewPage);
